import api from './axios';

const params = (idEmpresa) => (idEmpresa ? { id_empresa: idEmpresa } : undefined);

export const listUnidades = (incluirInativos) =>
  api.get('/unidades-medida/', { params: incluirInativos ? { incluir_inativos: true } : undefined });
export const createUnidade = (data, idEmpresa) => api.post('/unidades-medida/', data, { params: params(idEmpresa) });
export const updateUnidade = (id, data, idEmpresa) =>
  api.patch(`/unidades-medida/${id}`, data, { params: params(idEmpresa) });
